export const iconFontAwesomeMoneyMoneyCheck = (
	<i className="fa-solid fa-money-check"></i>
);
